<div class="modal-header">
  <h1 class="modal-title">{{ selectedCoBuyerId() ? 'Edit Co-Buyer' : 'Add Co-Buyer' }}</h1>
  <span (click)="closeModal()" role="button" class="ms-auto">
    <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
  </span>
</div>
<div class="modal-body">
  <co-buyer-form
    [prospectId]="prospectId()"
    [(selectedCoBuyerInput)]="selectedCoBuyerId"
    [onSubmit]="onSubmitObservable"
    (reload)="onReload()"
  ></co-buyer-form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-shadow" (click)="closeModal()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSaveClick()">Save</button>
</div>
